export const msalConfiguration = {
  clientId: 'ddeade10-dd42-46eb-92c4-959594bf93d7',
  authority: 'https://login.microsoftonline.com/14cb4ab4-62b8-45a2-a944-e225383ee1f9/',
  validateAuthority: true,
  redirectUri: 'https://www.gdb-ibl-inetum.services/home',
  postLogoutRedirectUri: 'https://www.gdb-ibl-inetum.services/',
  navigateToLoginRequestUrl: true,
  cacheLocation: 'localStorage',
  storeAuthStateInCookie: true,
  popUp: false,
  consentScopes: ['offline_access', 'openid'],
  // protectedResourceMap: [['https://graph.microsoft.com/v1.0/me', ['user.read']]],
  extraQueryParameters: {}
}
